<template>
  <div class="text-gray-900 bg-gray-50 font-sans py-12 p-4 sm:p-6">
    <div class="max-w-4xl mx-auto space-y-10">

      <!-- Carte de prestations sélectionnées -->
      <section class="mb-10" v-if="selectedServices.length">
        <h2 class="text-base sm:text-lg font-semibold mb-2">
          <span class="text-[#18b7bd]">1.</span> Prestation sélectionnée
        </h2>
        <div class="space-y-4">
          <div
            v-for="(service, index) in selectedServices"
            :key="index"
            class="bg-white rounded-xl shadow-md p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0"
          >
            <div class="text-sm text-gray-800 leading-tight max-w-full sm:max-w-[70%]">
              <p class="font-semibold mb-1">{{ service.nom }} - {{ service.prix }}€</p>
              <p class="text-gray-600 flex flex-wrap items-center gap-1">
                <span>{{ service.duree }} min</span>
               
              </p>
            </div>
            <button @click="removeService(index)" class="text-[#18b7bd] text-sm underline whitespace-nowrap">
              Supprimer
            </button>
          </div>
        </div>
        <button
          type="button"
          class="mt-6 inline-flex items-center gap-2 bg-gray-900 text-white text-sm font-normal rounded-md px-4 py-2 hover:bg-gray-800 transition"
          @click="showPrestationList = true"
        >
          <i class="fas fa-plus"></i> Ajouter une prestation à la suite
        </button>
      </section>

      <!-- Tabs -->
<section v-if="showPrestationList">
  <h2 class="text-2xl font-bold text-gray-900 mb-6 border-b pb-2">
    Soins et services vétérinaires
  </h2>

  <div
    v-for="(cat, index) in salon.categories"
    :key="cat._id"
    class="mb-6 border-b pb-4"
  >
    <!-- Titre catégorie -->
    <div
      @click="toggleCategorie(index)"
      class="flex justify-between items-center cursor-pointer group"
    >
      <h3
        class="text-xl font-semibold text-[#18b7bd] pl-2 border-l-4 border-[#18b7bd]"
      >
        {{ cat.nom }}
      </h3>
      <svg
        :class="{ 'rotate-180': openedCategorie === index }"
        class="w-5 h-5 text-[#18b7bd] transform transition-transform duration-300"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    <!-- Services -->
    <transition name="fade">
      <div v-if="openedCategorie === index" class="mt-4 space-y-4">
        <div v-if="cat.services && cat.services.length">
          <div
            v-for="service in cat.services"
            :key="service._id"
            class="p-4 rounded-xl transition bg-white shadow"
          >
            <div
              class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
            >
              <div
                class="text-lg font-semibold text-gray-900 break-words"
              >
                {{ service.nom }}
              </div>

              <div
                class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6 mt-2 sm:mt-0"
              >
                <div class="text-[#18b7bd] font-medium whitespace-nowrap">
                  {{ service.prix }} €
                </div>
                <div class="text-gray-500 whitespace-nowrap">
                  {{ service.duree }} min
                </div>
                <button
                  @click="addService(service)"
                  class="bg-[#18b7bd] text-white rounded-md px-4 py-2 font-semibold hover:bg-[#0f9297] transition whitespace-nowrap"
                >
                  Prendre rendez-vous
                </button>
              </div>
            </div>

            <p class="text-sm text-gray-600 mt-2 text-left">
              {{ service.description }}
            </p>
          </div>
        </div>
        <div v-else class="text-gray-500 italic mt-2">
          Aucune prestation dans cette catégorie.
        </div>
      </div>
    </transition>
  </div>
</section>


      <!-- Étape de sélection horaire -->
      <section v-if="selectedServices.length && !showPrestationList">
<TimeslotComponents
  :selectedServices="selectedServices"
  :firmId="firmId"
  @creneau-selectionne="handleCreneauSelectionne"
/>
       <button
  @click="confirmerRdv"
  class="mt-6 w-full bg-[#18b7bd] text-white font-semibold py-3 rounded-lg hover:bg-indigo-700 transition"
>
  Confirmer le rendez-vous
</button>
      </section>
    </div>
  </div>
</template>

  
<script>
import TimeslotComponents from '@/components/TimeslotComponents.vue';
import axios from 'axios';

export default {
  components: { TimeslotComponents },
  data() {
    return {
     salon: {
  categories: [],
},
      activeCategory: '',
      showPrestationList: true,
      openedCategorie: null,
      selectedServices: [],
      services: [],
      selectedCreneau: null,
    };
  },
 computed: {
  filteredServices() {
    return this.services.filter(s => s.category === this.activeCategory);
  },
  isReplanification() {
    return this.$route.query.replanifier === 'true';
  },
  firmId() {
    return this.$route.params.id;
  }
},

  methods: {
    toggleCategorie(index) {
  this.openedCategorie = this.openedCategorie === index ? null : index;
},
    async loadServicesFromQuery() {
      const ids = (this.$route.query.service || '').split(',').filter(Boolean);
      if (ids.length === 0) return;

      if (this.services.length === 0) {
        await this.fetchCategoriesWithServices();
      }

      const matchedServices = this.services.filter(service => ids.includes(service._id));
      this.selectedServices = matchedServices.map(service => ({ ...service }));

      if (this.selectedServices.length > 0) {
        this.showPrestationList = false;
      }
      console.log('service selectionner:  ', this.selectedServices)
    },

    async confirmerRdv() {
      if (!this.selectedCreneau) {
        alert("Veuillez sélectionner un créneau avant de confirmer.");
        return;
      }

      if (this.selectedServices.length === 0) {
        alert("Veuillez sélectionner au moins un service.");
        return;
      }

      const firmId = this.$route.params.id;
      const employeId = this.selectedCreneau.employeId;
      const serviceIds = this.selectedServices.map(s => s._id);
      const date = this.selectedCreneau.date;
      const heureDebut = this.selectedCreneau.slot;
      const token = localStorage.getItem('clientToken');
      const bookingId = this.$route.query.bookingId;

      const payload = {
        employeId,
        serviceIds,
        date,
        heureDebut,
      };

     try {
  const headers = {
    Authorization: `Bearer ${token}`
  };

  if (this.isReplanification && bookingId) {
    const response = await axios.put(`https://b53c7d5edf32.ngrok-free.app/api/appointment/replanifier/${bookingId}`, payload, { headers });
    alert("Rendez-vous replanifié !");
    console.log(response.data);
  } else {
    const clientId = localStorage.getItem('USERID');
    const response = await axios.post('https://b53c7d5edf32.ngrok-free.app/api/appointment/prendre', {
      ...payload,
      firmId,
      clientId
    }, { headers });

    // ✅ Si un paiement est requis, redirige automatiquement vers Stripe
    if (response.data.paiement && response.data.url) {
      window.location.href = response.data.url; // 🔁 redirection vers Stripe
      return; // ⛔ ne pas exécuter la suite
    }

    // ✅ Si aucun paiement requis, on confirme le RDV directement
    alert("Rendez-vous confirmé !");
    this.$router.push('/mes-rendez-vous')
    console.log(response.data);
  }
} catch (error) {  if (error.response && error.response.status === 401) {
      // Supprime le token et redirige vers la page de connexion
      localStorage.removeItem('adminToken');
      this.$router.push('/login'); // ou '/login' selon ta route
    }
  console.error("❌ Erreur :", error.response?.data || error.message);
  alert("Erreur : " + (error.response?.data?.message || error.message));
}

    },

    redirigerVersReplanification(serviceIds = [], bookingId) {
      const firmId = this.$route.params.id;
      this.$router.push({
        path: `/rendez-vous/${firmId}`,
        query: {
          replanifier: 'true',
          services: serviceIds.join(','),
          bookingId
        }
      });
    },

    handleCreneauSelectionne({ date, slot, employeId }) {
      this.selectedCreneau = { date, slot, employeId };
    },

    toggleDetails(service) {
      service.showDetails = !service.showDetails;
    },

addService(service) {
  const alreadySelected = this.selectedServices.find(s => s._id === service._id);
  if (!alreadySelected) {
    this.selectedServices.push({ ...service });
    this.showPrestationList = false;
    console.log(this.selectedServices)
  }
},

removeService(index) {
  this.selectedServices.splice(index, 1);
  if (this.selectedServices.length === 0) {
    this.showPrestationList = true;
  }
},


  async fetchCategoriesWithServices() {
  try {
    const res = await axios.get('https://b53c7d5edf32.ngrok-free.app/api/categorie/with-services');
    const data = res.data;

    this.salon.categories = data
      .filter(cat => cat.statut === 'Active')
      .map(cat => ({
        ...cat,
        nom: cat.nom.toUpperCase(),
        services: cat.services.map(service => ({
          ...service,
          showDetails: false
        }))
      }));

    // Remplir this.services si tu en as encore besoin pour loadServicesFromQuery
    this.services = this.salon.categories.flatMap(cat => cat.services);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('adminToken');
      this.$router.push('/login');
    }
    console.error('Erreur lors du chargement des catégories avec services:', error);
  }
},

  },
  mounted() {
    this.fetchCategoriesWithServices().then(() => {
      this.loadServicesFromQuery();
    });

  },
};
</script>

  